<template>
    <!-- Componente de Solicitações -->
    <div>
        <v-row >
            <v-col cols="12" sm="6" md="3" lg="3">
                <v-btn fab @click.stop="get_solicitacoes" title="atualizar" color="primary">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <modal-gdb ref="ref_modal_create_sol_visitante" :code="modal_code_create"
                    toolbar-title="Solicitar novo cadastro de visitante" dialogWidth="100%">
                    <template v-slot:activate-slot>
                        <span class="mx-1">
                            <v-btn>Nova Solicitação</v-btn>
                        </span>
                    </template>
                    <template v-slot:body>
                        <Solicitar @on-created="onCreateSolicitacao"/>
                    </template>
                </modal-gdb>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field v-model="search_solicitacao"
                    placeholder="Pesquisar" label="Pesquisar"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12">
                <v-data-table v-if="true"
                    :items="StateSolicitacoes"
                    :headers="headers"
                    :items-per-page="20"
                    :loading="StateSolicitacoesLoading"
                    loading-text="carregando..."
                    locale="pt-br"
                    :search="search_solicitacao"
                    no-data-text='Nenhum registro'
                    no-results-text='Nenhum registro encontrado'
                    class="custom-header-style"
                    >
                    <template #foto="{ item }">
                        <v-img class="my-2"
                            :src="'data:image/png;base64,'+item.foto"
                            width="50" style="border-radius:35px" />
                    </template>
                    <template #approve="{ item }">
                        <v-btn text @click.stop="selectSolicitacao(item)"> Revisar </v-btn>
                    </template>
                    <template #date_expire="{ item }">
                        {{$verify.formatarData(item.date_expire+" "+item.time_expire)}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <modal-gdb ref="ref_modal_read_sol_visitante" :code="modal_code"
            toolbar-title="Autorizar cadastro de visitante" dialogWidth="100%">
            <template v-slot:activate-slot>
                <span></span>
            </template>
            <template v-slot:body>
                <FormSolicitacao @on-changed="onFormChanged"
                    :formSolicitacao="selectedSolicitacao"/>
                <v-row v-if="selectedSolicitacao && selectedSolicitacao.created_by">
                    <v-col cols="12" sm="8">
                        <span class="overline">
                            Solicitado por
                            {{selectedSolicitacao.created_by.first_name}} {{selectedSolicitacao.created_by.last_name}}
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-btn class="ma-1"
                        @click.stop="update_solicitacao(selectedSolicitacao)"
                        color="info"> Atualizar
                    </v-btn>
                    <v-btn class="ma-1" v-if="$verify.pode_aprovar_solicitacao_visitante()"
                        @click.stop="approve_solicitacao(selectedSolicitacao)"
                        v-show="!!selectedSolicitacao.foto"
                        color="success"> Aprovar
                    </v-btn>
                    <v-btn class="ma-1"
                        @click.stop="delete_solicitacao(selectedSolicitacao)"
                        color="error"> Remover
                    </v-btn>
                </v-row>
            </template>
        </modal-gdb>
        <loading-gdb :dialog="StateSolicitacoesLoading || StateIDSecureVisitantesLoading"/>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FormSolicitacao from './FormSolicitacao.vue'
import Solicitar from './Solicitar.vue'
export default {
    name: 'IDSecureSolicitacoes',
    components:{
        FormSolicitacao, Solicitar
    },
    data:()=>({
        search_solicitacao:null,
        modal_code:'modal_read_sol_visitante',
        modal_code_create:'modal_create_sol_visitante',
        headers:[
            // { title: ' ', align: 'start', sortable: false, value: 'details', width:'10' },
            { title: 'Foto', align: 'start', sortable: true, value: 'foto', width:'90'},
            { title: 'Nome', align: 'start', sortable: true, value: 'name'},
            { title: 'CPF', align: 'start', sortable: false, value: 'cpf', width:'50'},
            { title: 'Data Limite', align: 'start', sortable: true, value: 'date_expire', width:'200'},
            { title: 'Solicitante', align: 'start', sortable: true, value: 'created_by.first_name', width:'50'},
            { title: 'Aprovar', align: 'start', sortable: true, value: 'approve', width:'50'},
        ],
        selectedSolicitacao:{},
    }),
    mounted(){
        this.get_solicitacoes()
    },
    methods:{
        ...mapActions(['GetSolicitacoesVisitantes',
                        'UpdateSolicitacaoVisitante',
                        'DeleteSolicitacaoVisitante',
                        'CreateIDSecureVisitanteBySolicitacao']),
        async update_solicitacao(item){
            const response = await this.UpdateSolicitacaoVisitante(item)
            if(response.status == 200){
                this.close_and_refresh()
            }
        },
        async approve_solicitacao(item){
            if (!item.foto){
                alert('Necessário adicionar uma foto!')
                return
            }
            const update_before = await this.UpdateSolicitacaoVisitante(item)
            if(update_before.status == 200){
                const response = await this.CreateIDSecureVisitanteBySolicitacao(item)
                if(response.status == 200){
                    this.close_and_refresh()
                }
            }
        },
        async delete_solicitacao(item){
            const conf = confirm('Tem certeza que deseja remover este registro?')
            if(conf){
                const response = await this.DeleteSolicitacaoVisitante(item.id)
                if(response.status == 204){
                    this.close_and_refresh()
                }
            }
        },
        async get_solicitacoes(){
            await this.GetSolicitacoesVisitantes({page_size:1000})
        },
        closeModal(){
            this.$refs.ref_modal_read_sol_visitante.dialog = false
        },
        close_and_refresh(){
            this.closeModal()
            this.get_solicitacoes()
        },
        selectSolicitacao(item){
            this.$refs.ref_modal_read_sol_visitante.dialog = true
            this.selectedSolicitacao = Object.assign({},item)
        },
        onFormChanged(item){
            this.selectedSolicitacao = Object.assign(this.selectedSolicitacao, item)
        },
        onCreateSolicitacao(created){
            this.$refs.ref_modal_create_sol_visitante.dialog = !created
            if (created){
                this.get_solicitacoes()
            }
        }
    },
    computed:{
        ...mapGetters(['StateSolicitacoes','StateSolicitacoesLoading', 'StateIDSecureVisitantesLoading']),
    },
}
</script>